import axiosInstance from 'api/axiosConfig'
import { ENDPOINTS } from 'api/endpoints'
import handleApiError from 'api/utils/handleApiError'
import { Message } from 'components/types'
import { useCallback } from 'react'

export type ListingNeighborhoodOption = {
  neighborhood: string
  listingCount: number
}

export async function loadNeighborhoodsForCity(
  city: string
): Promise<ListingNeighborhoodOption[]> {
  const trimmed = city.trim()
  if (trimmed.length < 2) return []

  try {
    const response = await axiosInstance.get<{
      success?: boolean
      data?: Array<{
        neighborhood?: string
        listingCount?: number
        listing_count?: number
      }>
    }>(ENDPOINTS.FILTER.LISTING_NEIGHBORHOODS, {
      params: { city: trimmed },
    })

    if (!response.data?.success || !Array.isArray(response.data.data)) {
      return []
    }

    return response.data.data
      .map(item => ({
        neighborhood: String(item.neighborhood ?? '').trim(),
        listingCount: Number(item.listingCount ?? item.listing_count ?? 0),
      }))
      .filter(item => item.neighborhood !== '')
  } catch (err) {
    // Do not rethrow — callers must leave the loading state.
    console.error('Failed to fetch neighborhoods', err)
    return []
  }
}

const useFilterService = () => {
  const loadFilterOptions = useCallback(async (): Promise<Message[]> => {
    try {
      const response = await axiosInstance.get<Message[]>(
        ENDPOINTS.FILTER.LOAD_FILTER_OPTIONS
      )

      if (!response.data) {
        throw new Error()
      }

      return response.data
    } catch (err) {
      handleApiError('Failed to fetch messages', err)
      return []
    }
  }, [])

  return { loadFilterOptions, loadNeighborhoodsForCity }
}

export default useFilterService
